import React from "react"
import { Grid } from "@material-ui/core"
import SelectInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/SelectInput"

import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"

import useContentEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useContentEditor"

import { ChatBotFlowBlockContent } from "@/protocols/chatBot"
import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"
import { AgentOption } from "@/protocols/chatBotConstructor"

type AIAgentSectionEditorProps = {
	onSave: (agentOption: AgentOption) => void
	chatBotFlowBlockContent: ChatBotFlowBlockContent
	selectedAgent?: AgentOption
}

const AIAgentSectionEditor: React.FC<AIAgentSectionEditorProps> = (props) => {
	const {
		chatBotFlowBlockContent,
		onSave,
		children,
		selectedAgent
	} = props

	const contentEditor = useContentEditor({ chatBotFlowBlockContent })
	const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()

	const agents = chatBotFlowConstructorStore.constructionResources.agents

	const handleSave = async () => {
		const currentAgentId = contentEditor.content.agent?.id

		const agent = agents.find(agent => agent.id === currentAgentId)

		if (agent) {
			onSave(agent)
		}
	}

	return (
		<BlockBodySectionEditor
			title="SELECIONE UM AGENTE DE IA"
			onSave={handleSave}
			onOpen={contentEditor.reset}
			AsideDrawerProps={{
				children: (
					<Grid
						container
						spacing={2}
					>
						<Grid
							item
							xs={12}
						>
							<SelectInput
								onChange={(agent) => {
									contentEditor.changeContent({
										agent: {
											id: agent?.id
										}
									})
								}}
								placeholder="Agentes"
								getOptionSelected={(option, value) => option.id === value.id}
								noOptionsText="Sem agentes disponíveis"
								options={agents}
								value={selectedAgent}
								getOptionLabel={agent => `${agent.name} (${agent.isActive ? "Ativo" : "Inativo"})`}
								getOptionDisabled={agent => !agent.isActive}
								onUpdate={async () => {
									await chatBotFlowConstructorStore.loadSpecificConstructionResources("agents")
								}}
							/>
						</Grid>
					</Grid>
				)
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default AIAgentSectionEditor
